module.exports = __webpack_public_path__ + "static/media/customer-plantmade.1ea4dbd3.png";